export const fetchPublishedApartments = async () => {
  try {
    const response = await fetch('https://centraljasna.sk/wp-json/custom-api/v1/pages');
    const data = await response.json();

    // Filtrovanie len publikovaných apartmánov s názvom obsahujúcim "Apartmán"
    return data.filter((item) => item.status === 'Published' && item.title.includes('Apartmán'));
  } catch (error) {
    console.error('Chyba pri načítavaní dát z API:', error);
    return [];
  }
};

export const checkApartmentAvailability = async (floors) => {
  const publishedApartments = await fetchPublishedApartments();

  for (const floorKey in floors) {
    const apartments = floors[floorKey].apartments;

    for (const apartment of apartments) {
      // Hľadanie apartmánu podľa URL
      const matchingApartment = publishedApartments.find((item) => item.url === apartment.pdf);

      if (matchingApartment) {
        // Logika pre nastavenie "reserved" a "sold"
        if (matchingApartment.availability_status === 'Booked') {
          apartment.reserved = true;
          apartment.sold = false;
        } else if (matchingApartment.availability_status === 'Sold') {
          apartment.sold = true;
          apartment.reserved = false;
        } else {
          // Ak apartmán nie je "Booked" ani "Sold", nastavíme false
          apartment.reserved = false;
          apartment.sold = false;
        }
      } else {
        // Ak apartmán nie je nájdený v publikovaných, nastavíme na false
        apartment.reserved = false;
        apartment.sold = true;
      }
    }
  }
};
